import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { CloseIcon } from "@icarius-icons";
import { Dialog, DialogTitle, DialogContent, Chip } from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import PaperDraggable from "@icarius-common/paperDraggable";
import DialogTransition from "@icarius-common/dialogTransition";
import { openDialogAction } from "@icarius-common/dialog/actions";
import ProfileImg from "@icarius-common/profileImg";
import { getIsLoading } from "@icarius-pages/myTraining/selectors";
import { getAvatar } from "@icarius-app/selectors";
import { getLocalizedString } from "@icarius-localization/strings";
import useResetStateByKey from "@icarius-utils/hooks/useResetStateByKey";
import {
    createAnswerQuestionFromTrainingAction,
    deleteAnswerFromTrainingAction,
    deleteQuestionFromTrainingAction,
    updateAnswerQuestionFromTrainingAction,
    updateQuestionFromTrainingAction,
} from "@icarius-pages/myTraining/actions";
import Item from "./item";
import Form from "./form";

const QuestionDialog = (props) => {
    const { open, trainingData, activityData, questionData, handleClose } = props;

    const { key, resetState } = useResetStateByKey();

    const dispatch = useDispatch();
    const avatar = useSelector(getAvatar);
    const isLoading = useSelector(getIsLoading);

    const handleUpdateQuestion = (data, callback) => {
        dispatch(updateQuestionFromTrainingAction(trainingData.id, activityData.id, questionData.id, data)).then(
            (resp) => {
                if (resp.status === 200) {
                    if (callback) callback();
                }
            }
        );
    };

    const handleDeleteQuestion = () => {
        dispatch(
            openDialogAction({
                title: getLocalizedString("atention"),
                msg: getLocalizedString("deleteQuestionConfirmation"),
                onConfirm: () => {
                    handleClose();
                    dispatch(deleteQuestionFromTrainingAction(trainingData.id, activityData.id, questionData.id));
                },
            })
        );
    };

    const handleCreateAnswer = (data, callback) => {
        dispatch(createAnswerQuestionFromTrainingAction(trainingData.id, activityData.id, questionData.id, data)).then(
            (resp) => {
                if (resp.status === 200) {
                    if (callback) callback();
                }
            }
        );
    };

    const handleUpdateAnswer = (answerId, data, callback) => {
        dispatch(
            updateAnswerQuestionFromTrainingAction(trainingData.id, activityData.id, questionData.id, answerId, data)
        ).then((resp) => {
            if (resp.status === 200) {
                if (callback) callback();
            }
        });
    };

    const handleDeleteAnswer = (answerId) => {
        dispatch(
            openDialogAction({
                title: getLocalizedString("atention"),
                msg: getLocalizedString("deleteAnswerConfirmation"),
                onConfirm: () =>
                    dispatch(
                        deleteAnswerFromTrainingAction(trainingData.id, activityData.id, questionData.id, answerId)
                    ),
            })
        );
    };

    if (!open) return null;

    return (
        <Dialog
            open={open}
            TransitionComponent={DialogTransition}
            PaperComponent={PaperDraggable}
            maxWidth={"md"}
            fullWidth={true}
        >
            <div className={"dialog-container"}>
                <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
                    {`${questionData.title} (${questionData.activityName})`}
                    <DialogTitleDivider />
                </DialogTitle>
                <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
                <DialogContent style={{ paddingTop: 0, paddingBottom: 20 }}>
                    {questionData.isClosed && (
                        <Chip
                            size="small"
                            style={{
                                width: "100%",
                                background: "var(--ownBlue)",
                                color: "white",
                                marginBottom: 15,
                            }}
                            label={getLocalizedString("closed")}
                        />
                    )}
                    <Item
                        data={questionData}
                        isLoading={isLoading}
                        readOnly={questionData.isClosed || !questionData.canEdit}
                        handleDeleteQuestion={handleDeleteQuestion}
                        handleUpdateQuestion={handleUpdateQuestion}
                        isQuestion
                    />
                    <div
                        style={{
                            marginTop: 10,
                            marginLeft: 55,
                            display: "flex",
                            flexDirection: "column",
                            gap: 10,
                        }}
                    >
                        {questionData.answers.map((item) => {
                            return (
                                <Item
                                    key={item.id}
                                    data={item}
                                    isLoading={isLoading}
                                    readOnly={questionData.isClosed || !item.canEdit}
                                    handleDeleteAnswer={() => handleDeleteAnswer(item.id)}
                                    handleUpdateAnswer={(data, callback) => handleUpdateAnswer(item.id, data, callback)}
                                />
                            );
                        })}
                    </div>
                    {!questionData.isClosed && (
                        <div
                            style={{
                                marginTop: 20,
                                display: "flex",
                                gap: 10,
                            }}
                        >
                            <ProfileImg image={avatar} size={45} />
                            <Form
                                key={key}
                                handleCreate={handleCreateAnswer} // aca solo se pueden crear respuestas
                                handleClose={resetState}
                            />
                        </div>
                    )}
                </DialogContent>
            </div>
        </Dialog>
    );
};

export default QuestionDialog;
